import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden pointer-events-none select-none" }
const _hoisted_2 = {
  style: {"filter":"blur(0px)"},
  class: "relative w-full overflow-hidden h-8.5rem md:h-15rem"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute top-0 bottom-0 w-full bg-transparent",
  style: {"height":"100%","z-index":"999999"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Esercizio 1", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Esercizio 2", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Esercizio 3", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.participation.slots[0])
        ? (_openBlock(), _createBlock(_component_AbstractEventParticipationSlot, {
            key: 0,
            "model-value": _ctx.participation.slots[0],
            "allow-edit-submission": true,
            class: "thumbnail-slot -z-1"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["model-value"]))
        : _createCommentVNode("", true),
      (_ctx.participation.slots[1])
        ? (_openBlock(), _createBlock(_component_AbstractEventParticipationSlot, {
            key: 1,
            "model-value": _ctx.participation.slots[1],
            "allow-edit-submission": true,
            class: "my-4 thumbnail-slot"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["model-value"]))
        : _createCommentVNode("", true),
      (_ctx.participation.slots[2])
        ? (_openBlock(), _createBlock(_component_AbstractEventParticipationSlot, {
            key: 2,
            "model-value": _ctx.participation.slots[2],
            "allow-edit-submission": true,
            class: "thumbnail-slot"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["model-value"]))
        : _createCommentVNode("", true)
    ])
  ]))
}